<mat-list class="inline-list" *ngIf="allowLoginMethod.length > 1">
    <mat-list-item [class.active]="selectedIndex === index" *ngFor="let item of allowLoginMethod ; let index = index"
                   (click)="getLoginMethod(item, index)">
        <div class="icon-text" [ngSwitch]="item">
    <span class="icon">
      <mat-icon *ngSwitchCase="'EMAIL'"  aria-hidden="false" aria-label="Mail icon">mail</mat-icon>
      <mat-icon *ngSwitchCase="'MOBILE'" aria-hidden="false" aria-label="Phone icon">phone_iphone</mat-icon>
      <mat-icon *ngSwitchCase="'USER_NAME'" aria-hidden="false" aria-label="Badge icon">badge</mat-icon>
    </span>
            <span class="text">{{ getTitleCaseWord(item) | translate }} </span>
        </div>
    </mat-list-item>
</mat-list>

<div fxLayout="column" fxLayoutAlign="space-around left" class="mobile-input">
    <div fxflex="100%" fxFlex.xs="100%" style="width: 100%; float: left;">
        <dynamic-form #dynamicFormComponent [fields]="fields" [options]="dynamicFormOptions" [isSubmitted]="isSubmitBtnClicked" [refreshEnabled]="true"
                      (onSubmit)="_onSubmit($event)" style="width: 100%; float: left;" class="dynamic"></dynamic-form>
    </div>

    <!--custom-->
    <div *ngIf="gloTypeRegister==='create'" fxLayout="column" fxLayoutAlign="space-around left" class="data-protection-content" style="margin-top: 0px;">
        <p class="globus-text">Datenschutz</p>
        <p class="info-text" *ngIf="isAppUser">Es gelten unsere <a href="af://openBrowser/https://www.globus-baumarkt.de/datenschutz/">Datenschutzbestimmungen</a> und <a href="af://openBrowser/https://www.globus-baumarkt.de/agb/">AGB</a>.</p>
        <p class="info-text" *ngIf="!isAppUser">Es gelten unsere <a href="https://www.globus-baumarkt.de/datenschutz/">Datenschutzbestimmungen</a> und <a href="https://www.globus-baumarkt.de/agb/">AGB</a>.</p>
        <p class="pw-hint">* Pflichtfelder</p>
    </div>

    <div fxflex="100%" class="btn1" style="width: 100%; float: left;" class="dynamic">
        <app-button [btnOption]="buttonOptions.login" class="login-btn">
        </app-button>
    </div>
</div>

<div class="text-success" *ngIf="password_reseted">
    {{'PASSWORD_CHANGED' | translate}}
</div>

<!--custom-->
<div *ngIf="shopSource==='checkout'" class="globus-shop-source-wrapper">
    <span class="custom-login-info">Konto erstellen und Vorteile Sichern!</span>

    <ul>
        <li>Zeit bei Bestellungen sparen</li>
        <li>Einkaufsliste speichern</li>
        <li>mehrere Lieferadressen verwalten</li>
        <li>Bestellungen verwalten</li>
    </ul>

    <a class="secondary-button-globus" tabindex="0" (keydown.enter)="_onClickRegisterGLO($event)" (click)="_onClickRegisterGLO($event)">Konto erstellen</a>
</div>

<div *ngIf="shopSource==='checkout'" fxLayout="column" fxLayoutAlign="space-around left" class="mobile-input" style="margin-top: 50px;">
    <p class="globus-text">Ohne Vorteile bestellen</p>

    <a class="secondary-button-globus" tabindex="0" href="/checkout/register/address?guest=1">
        Als Gast bestellen
    </a>

    <p class="pw-hint"><br>* Pflichtfelder</p>
</div>

<div *ngIf="gloTypeRegister!=='create' && shopSource!=='checkout'" fxLayout="column" fxLayoutAlign="space-around left" class="mobile-input" style="margin-top: 50px;">
    <h2 role="heading" class="globus-text">Sie haben noch kein Kundenkonto?</h2>

    <a class="secondary-button-globus" tabindex="0" (keydown.enter)="_onClickRegisterGLO($event)" (click)="_onClickRegisterGLO($event)">
        Konto erstellen
    </a>
</div>

<div class="mat-error" role="alert">
    {{errorMsg | translate}}
</div>

<div *ngIf="errorMessage" class="mat-error">
    {{ errorMessage | uppercase | translate }}
</div>

<div *cidPageLoader="pageLoading"></div>
